import { c as _c } from "react/compiler-runtime";
import type { AmlHitMedia } from '@onefootprint/request-types/dashboard';
import { CopyButton } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import toReadableString from '@/utils/to-readable-string';
import HitsMedia from '../../../hits-media';
type HitItemRowProps = {
  fieldName: string;
  fieldValue: string | string[] | AmlHitMedia[] | number;
};
const HitItemRow = t0 => {
  const $ = _c(24);
  const {
    fieldName,
    fieldValue
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.riskSignals.drawer.hits"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const renderMatchTypes = _temp2;
  let t2;
  if ($[1] !== t) {
    t2 = url => <div className="flex items-center justify-between w-full max-w-full"><p className="truncate text-body-2">{url}</p><CopyButton ariaLabel={t(_temp3)} contentToCopy={url} tooltip={{
        position: "bottom"
      }} /></div>;
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const renderLocationUrlValue = t2;
  const renderGeneralValue = _temp4;
  const renderMedia = _temp5;
  let t3;
  if ($[3] !== fieldName || $[4] !== fieldValue || $[5] !== renderLocationUrlValue) {
    t3 = () => {
      if (fieldName === "matchTypes") {
        return renderMatchTypes(fieldValue as string[]);
      }
      if (fieldName === "locationurl" || fieldName === "relatedUrl") {
        return renderLocationUrlValue(fieldValue as string);
      }
      if (fieldName === "relevantMedia" && Array.isArray(fieldValue)) {
        return renderMedia(fieldValue as AmlHitMedia[]);
      }
      return renderGeneralValue(fieldValue as string);
    };
    $[3] = fieldName;
    $[4] = fieldValue;
    $[5] = renderLocationUrlValue;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const renderValue = t3;
  let t4;
  if ($[7] !== fieldName || $[8] !== fieldValue || $[9] !== t) {
    t4 = () => {
      if (fieldName === "showAll") {
        return t(_temp6, {
          count: fieldValue as number
        });
      }
      if (fieldName === "locationurl") {
        return t(_temp7);
      }
      if (fieldName === "relatedUrl") {
        return t(_temp8);
      }
      if (fieldName === "relevantMedia") {
        return t(_temp9);
      }
      return toReadableString(fieldName);
    };
    $[7] = fieldName;
    $[8] = fieldValue;
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const getLabelText = t4;
  const t5 = `label-${fieldName}`;
  const t6 = `label-${fieldName}`;
  let t7;
  if ($[11] !== getLabelText) {
    t7 = getLabelText();
    $[11] = getLabelText;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <p id={t6} className="text-left text-label-2 text-tertiary">{t7}</p>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== renderValue) {
    t9 = renderValue();
    $[16] = renderValue;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = <div className="text-body-2">{t9}</div>;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t5 || $[22] !== t8) {
    t11 = <div className="flex flex-col gap-1 py-3 border-t border-dashed first:border-t-0 border-t-tertiary" aria-labelledby={t5}>{t8}{t10}</div>;
    $[20] = t10;
    $[21] = t5;
    $[22] = t8;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
};
export default HitItemRow;
function _temp(str) {
  return toReadableString(str);
}
function _temp2(matchTypes) {
  return matchTypes.map(_temp).join(", ");
}
function _temp3($) {
  return $.copy;
}
function _temp4(value) {
  const capitalizedValue = value && value.length !== 0 ? value.charAt(0).toUpperCase() + value.slice(1) : value;
  return <p className="text-body-2">{capitalizedValue}</p>;
}
function _temp5(media) {
  return <HitsMedia mediaList={media} />;
}
function _temp6($_0) {
  return $_0.showAll.label;
}
function _temp7($_1) {
  return $_1.locationUrl;
}
function _temp8($_2) {
  return $_2.relatedUrl;
}
function _temp9($_3) {
  return $_3.relevantMedia;
}